import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {InsightsService} from "../../services/insights/insights.service";
import * as Highcharts from 'highcharts/highcharts';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {SolidgaugeChartService} from "../../services/solidgauge-chart/solidgauge-chart.service";
import HighchartsMore from "highcharts/highcharts-more";

HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);

@Component({
  selector: 'app-participation-overall',
  templateUrl: './participation-overall.component.pug',
  styleUrls: ['./participation-overall.component.scss'],
  standalone: false
})
export class ParticipationOverallComponent implements OnInit, OnChanges {

  @Input() start!: any;
  @Input() end!: any;
  @Input() filterBy!: any;
  @Input() questionnaire!: any;
  @Input() defaultState!: string;
  @Output() selectionChange = new EventEmitter();
  data: any = []
  unresponsive = 0
  participated = 0
  submitted = 0
  optedIn = 0
  declined = 0
  updateUnresponsive = false
  updateParticipated = false
  updateSubmitted = false
  updateOptedIn = false
  updateDeclined = false

  selected = '';
  Highcharts: typeof Highcharts = Highcharts;
  participatedChartOptions = SolidgaugeChartService.getOptions(this.participated, '#DE8C02', 'rgba(222,140,2,0.1)');
  submittedChartOptions = SolidgaugeChartService.getOptions(this.submitted, '#32735F', 'rgba(50,115,95,0.1)');
  optedInChartOptions = SolidgaugeChartService.getOptions(this.optedIn, '#32735F', 'rgba(50,115,95,0.1)');
  declinedChartOptions = SolidgaugeChartService.getOptions(this.declined, '#AF0001', 'rgba(175,0,1,0.1)');
  unresponsiveChartOptions = SolidgaugeChartService.getOptions(this.unresponsive, '#000000', 'rgba(0,0,0,0.1)');

  constructor(private insightsService: InsightsService,
              private alertList: AlertBannerService,) {
  }

  ngOnInit(): void {
    this.switchSelected(this.defaultState);
  }

  private loadAndSetData() {
    this.insightsService.getParticipationOverall(this.start, this.end, this.questionnaire, this.filterBy, 'exit').subscribe(data => {

      this.data = data;
      this.unresponsive = this.participated = this.submitted = this.optedIn = this.declined = 0;

      for (let d of this.data) {
        if (d['state'] === 'unresponsive') {
          this.unresponsive = d['participation']
        } else if (d['state'] === 'participated') {
          this.participated = d['participation']
        } else if (d['state'] === 'submitted') {
          this.submitted = d['participation']
        } else if (d['state'] === 'opted_in') {
          this.optedIn = d['participation']
        } else if (d['state'] === 'declined') {
          this.declined = d['participation']
        }
      }

      this.participatedChartOptions = SolidgaugeChartService.getOptions(this.participated, '#DE8C02', 'rgba(222,140,2,0.1)');
      this.submittedChartOptions = SolidgaugeChartService.getOptions(this.submitted, '#32735F', 'rgba(50,115,95,0.1)');
      this.optedInChartOptions = SolidgaugeChartService.getOptions(this.optedIn, '#32735F', 'rgba(50,115,95,0.1)');
      this.declinedChartOptions = SolidgaugeChartService.getOptions(this.declined, '#AF0001', 'rgba(175,0,1,0.1)');
      this.unresponsiveChartOptions = SolidgaugeChartService.getOptions(this.unresponsive, '#000000', 'rgba(0,0,0,0.1)');
    }, error => {
      console.log(error);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    });
  }

  switchSelected(selected: any) {
    // Deselect old
    switch (this.selected) {
      case "optedIn":
        if (this.optedInChartOptions && this.optedInChartOptions.chart) {
          this.updateOptedIn = true;
        }
        break
      case "submitted":
        if (this.submittedChartOptions && this.submittedChartOptions.chart) {
          this.updateSubmitted = true;
        }
        break
      case "declined":
        if (this.declinedChartOptions && this.declinedChartOptions.chart) {
          this.updateDeclined = true;
        }
        break
      case "unresponsive":
        if (this.unresponsiveChartOptions && this.unresponsiveChartOptions.chart) {
          this.updateUnresponsive = true;
        }
        break
      default:
        if (this.participatedChartOptions && this.participatedChartOptions.chart) {
          this.updateParticipated = true;
        }
    }

    this.selected = selected;
    // Select new
    switch (this.selected) {
      case "optedIn":
        if (this.optedInChartOptions && this.optedInChartOptions.chart) {
          this.optedInChartOptions.chart.backgroundColor = '';
          this.updateOptedIn = true;
        }
        break
      case "submitted":
        if (this.submittedChartOptions && this.submittedChartOptions.chart) {
          this.submittedChartOptions.chart.backgroundColor = '';
          this.updateSubmitted = true;
        }
        break
      case "declined":
        if (this.declinedChartOptions && this.declinedChartOptions.chart) {
          this.declinedChartOptions.chart.backgroundColor = '';
          this.updateDeclined = true;
        }
        break
      case "unresponsive":
        if (this.unresponsiveChartOptions && this.unresponsiveChartOptions.chart) {
          this.unresponsiveChartOptions.chart.backgroundColor = '';
          this.updateUnresponsive = true;
        }
        break
      default:
        if (this.participatedChartOptions && this.participatedChartOptions.chart) {
          this.participatedChartOptions.chart.backgroundColor = '';
          this.updateParticipated = true;
        }
    }

    this.selectionChange.emit(this.selected);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadAndSetData();
  }
}
